import Box from '@mui/material/Box';
import { memo } from 'react';

import { IconAlertCircle as ErrorOutlineRoundedIcon } from '@/components/icon/tabler/IconAlertCircle';

interface Props {
  message?: string;
}

/** Signal field error: icon plus the validation message, for helper text slots. */
const AuthFieldError = ({ message }: Props) => {
  if (!message) return null;

  return (
    <Box component="span" sx={sx.root}>
      <ErrorOutlineRoundedIcon aria-hidden="true" sx={sx.icon} />
      {message}
    </Box>
  );
};

export default memo(AuthFieldError);

const sx = {
  root: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    gap: '6px',
    fontSize: 13,
    lineHeight: 1.4,
  },
  icon: { fontSize: 16, flex: 'none', mt: '1px' },
};
